import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from 'src/app/common/dialog-confirm/dialog-confirm.component';
@Component({
  selector: 'app-submitted-batch',
  templateUrl: './submitted-batch.component.html',
  styleUrls: ['./submitted-batch.component.scss']
})
export class SubmittedBatchComponent implements OnInit {
    tableSelectedColumn: ColDef[]|any = [];
    modalConfigBlocked: ModalConfig;

    @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
   
    public defaultColDef: ColDef|any = {
      flex: 1,
      minWidth: 150,
      filter: true,
      resizable: true,
      sortable:true,
      
    }
    
    constructor(private _snackBar: MatSnackBar, public dialog: MatDialog){}
  
    ngOnInit(): void {
      this.modalConfigBlocked = {
        modalTitle: "Document",
        modalSize: 'xl',
     
        hideDismissButton(): boolean {
          return true
        },
        hideCloseButton(): boolean {
          return true
        }
      }
    }
    
    
    columnDefs: ColDef[] = [
      { field: 'serialNo' },
      { field: 'BRN' },
     
      {
        headerName: "Upload File",
        cellRenderer: () => {
          return '<button class="btn btn-primary btn-sm ">Upload</button>';
        }
      }
  ];
  
  rowData = [
      { serialNo: '1', BRN:"XYZ",uploadFile:""},
      { serialNo: '2', BRN:"XYZ",uploadFile:""},
      { serialNo: '3', BRN:"XYZ",uploadFile:""},
      { serialNo: '4', BRN:"XYZ",uploadFile:""},
      { serialNo: '5', BRN:"XYZ",uploadFile:""}
  
  ];
  
  onCellClicked(evt:any) {
    if (evt.colDef.headerName === "Upload File") {
      const selectedRow = evt.data;
      this.modalblockedComponent.open();

    }
  }
  public files: any[] = [];



  /**
   * on file drop handler
   */
  onFileDropped($event: any[]) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event: any) {
    const files=event.files;
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }


  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number, decimals: number) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
